import { Component, Input, OnInit } from '@angular/core';
import { IonNav } from '@ionic/angular';
import { TrxServicesCardPage } from '../trxservices-card/trxservices-card.page';
import { TrxServicesAchPage } from '../trxservices-ach/trxservices-ach.page';
import { CaseService } from 'src/app/services/case.service';
import { TranslateService } from '@ngx-translate/core';
import { DdConsentFormPage } from '../../../../payment-plan/dd-consent-form/dd-consent-form.page';
@Component({
  selector: 'app-trxservices-method',
  templateUrl: './trxservices-method.page.html',
  styleUrls: ['./trxservices-method.page.scss'],
})
export class TrxServicesMethodPage implements OnInit {
  @Input() caseData;
  @Input() caseId;
  @Input() amount;
  @Input() totalOutstandingWithSymbol;
  @Input() debtorDetails;
  @Input() responseData;
  @Input() caseDetails;
  paymentMethod = [
    {
      title: this.translate.instant('CARD_PAYMENT.TITLE'),
      type: 'card',
      icon: 'card-outline',
      src: null,
    },
    {
      title: this.translate.instant('ACH_PAYMENT.TITLE'),
      type: 'ach',
      icon: 'card-outline',
      src: 'assets/icon/ach2.svg',
    },
  ];

  constructor(private ionNav: IonNav,     private caseService: CaseService,
    private translate: TranslateService
    ) {}

  ngOnInit() {
    const portalSettings = JSON.parse(localStorage.getItem('portal_settings') || 'null');
    const payment_type: any = portalSettings?.payment_type?.trxServices || {};
 
    if (payment_type.options?.length) {
      this.paymentMethod = this.paymentMethod.filter(method =>
        payment_type.options.includes(method.type)
      );
    }

    if (payment_type.option_labels && Object.keys(payment_type.option_labels).length) {
      this.paymentMethod = this.paymentMethod.map(method => ({
        ...method,
        title: payment_type.option_labels[method.type] ?? method.title
      }));
    }
  }

  handleMethodClick(type) {
    if (type === 'card') {
      this.caseService.makeTrxServicesPaymentRequest(this.caseId, { amount: this.responseData.net_amount, gatewayId : this.responseData.id, type : type })
      .subscribe(async (res: any) => {
        if (res.result) {
      this.ionNav.push(TrxServicesCardPage, {
        amount: this.amount,
        caseId: this.caseId,
        totalOutstandingWithSymbol: this.totalOutstandingWithSymbol,
        debtorDetails: this.debtorDetails,
        responseData: res.data,
        caseDetails: this.caseDetails,
      });
      }
      });
    } else if (type == 'ach') {
      if (this.caseService.isDdConsentFormEnabled()) {
        this.caseService.setPaymentData({ amount: this.amount });
        this.ionNav.push(DdConsentFormPage, {
          caseData: this.caseData || this.caseDetails,
          debtorDetails: this.debtorDetails,
          amount: this.amount,
        });
        return;
      }
      this.caseService.makeTrxServicesPaymentRequest(this.caseId, { amount: this.responseData.net_amount, gatewayId : this.responseData.id, type : type })
      .subscribe(async (res: any) => {
        if (res.result) {
          this.ionNav.push(TrxServicesAchPage, {
            amount: this.amount,
            caseId: this.caseId,
            totalOutstandingWithSymbol: this.totalOutstandingWithSymbol,
            debtorDetails: this.debtorDetails,
            responseData: res.data,
            caseDetails: this.caseDetails,
          });
        }
      });
  }
}
}
